import './styles.css.scss'

import {MDCRipple} from '@material/ripple';


function initPublicScriptsShowPage() {
  const iframeCon = document.querySelector('.iframe-container')
  const fullscreenBtn = document.querySelector('.notebook-html .fullscreen-button')
  const exitFullscreenBtn = document.querySelector('.iframe-container .mdc-icon-button')
  if (exitFullscreenBtn) {
    new MDCRipple(exitFullscreenBtn)
    exitFullscreenBtn.addEventListener('click', e => {
      iframeCon.classList.toggle("fullscreen")
    })
  }
  if (fullscreenBtn) {
    new MDCRipple(fullscreenBtn)
    fullscreenBtn.addEventListener('click', e => {
      iframeCon.classList.toggle("fullscreen")
    })
  }
  if (iframeCon) {
    iframeCon.querySelector('iframe').contentDocument.addEventListener('keydown', onEscapePress)
    document.addEventListener('keydown', onEscapePress)
  }
  function onEscapePress (event) {
    if(event.key === "Escape"){
      iframeCon.classList.remove("fullscreen")
    }
  }
}

window.addEventListener('initPublicScriptsShowPage', initPublicScriptsShowPage);